/**
 * @generated SignedSource<<60b33f26be751e77e82a94d85c0a1264>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateCostPeriodInput = {
  startDay?: number | null;
  startMonth?: number | null;
  startYear?: number | null;
  cost?: number | null;
  personId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createCostPeriodMutationModernMutation$variables = {
  input: CreateCostPeriodInput;
};
export type createCostPeriodMutationModernMutation$data = {
  readonly createCostPeriod: {
    readonly costPeriod: {
      readonly node: {
        readonly id: string;
        readonly startDay: number | null;
        readonly startMonth: number | null;
        readonly startYear: number | null;
        readonly cost: number | null;
      } | null;
    } | null;
  } | null;
};
export type createCostPeriodMutationModernMutation = {
  variables: createCostPeriodMutationModernMutation$variables;
  response: createCostPeriodMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCostPeriodPayload",
    "kind": "LinkedField",
    "name": "createCostPeriod",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CostPeriodTypeEdge",
        "kind": "LinkedField",
        "name": "costPeriod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CostPeriod",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cost",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createCostPeriodMutationModernMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createCostPeriodMutationModernMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9a898f3f2ac8265a77b7ebe9e93e400a",
    "id": null,
    "metadata": {},
    "name": "createCostPeriodMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation createCostPeriodMutationModernMutation(\n  $input: CreateCostPeriodInput!\n) {\n  createCostPeriod(input: $input) {\n    costPeriod {\n      node {\n        id\n        startDay\n        startMonth\n        startYear\n        cost\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "056cb97e0617cd5647fa84c7c80beace";

export default node;
